export enum SearchTypes {
    ALL = "All",
    COMPOSER = "Composer",
    ARTIST = "Artist",
    ROLE = "CharacterOrRole",
}

export enum SortTypes {
    NONE = "",
    TITLE = "title",
    COMPOSER = "composer",
}
